import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar } from 'react-chat-elements';
import { Spinner } from 'react-bootstrap';
import { useDebounce } from '../../../hooks';
import {
    createChatAPI,
    getAllChatsAPI,
    getAllChatUsersAPI,
} from '../../../utils/apiServices/chatsAPI';
import { CURRENT_VIEW, DEFAULT_AVATAR_URL, enrichUsersWithAvatarUrls } from './constant';
import { getProfileImage, popup } from '../../../utils';
import {
    initializeChatUsers,
    initializeMessages,
    setCurrentView,
    setSelectedUser,
} from '../../../redux';
import { isEmpty, set } from 'lodash';
import { ChatIcon } from '../../../assets/svg';

export const NewChatView = ({ managementId, search }) => {
    const dispatch = useDispatch();
    const chatUsers = useSelector((s) => s.chat.chatUsers);
    const [isFetching, setIsFetching] = useState(false);

    const getAllChatUsers = useDebounce(async () => {
        setIsFetching(true);
        try {
            const { data } = await getAllChatUsersAPI({
                csm_id: managementId,
                search,
                limit: 150,
            });
            const users = await enrichUsersWithAvatarUrls({ data });
            dispatch(initializeChatUsers(users));
            dispatch(setSelectedUser({}));
            dispatch(initializeMessages([]));
        } catch (error) {
            popup('error', error.message || 'Unable to fetch Chat Users');
        } finally {
            setIsFetching(false);
        }
    }, 500);

    useEffect(() => {
        if (managementId) {
            getAllChatUsers();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [managementId, search]);

    const initiateChat = async (userId) => {
        setIsFetching(true);
        try {
            const {
                data: [chatData],
            } = await getAllChatsAPI({
                management_id: managementId,
                user_id: userId,
            });
            if (isEmpty(chatData)) {
                const { data: newChat } = await createChatAPI({
                    management_id: managementId,
                    user_id: userId,
                });
                const selectedUser = structuredClone(newChat);
                const avatar = newChat?.avatar
                    ? await getProfileImage({ profileImg: newChat?.avatar })
                    : DEFAULT_AVATAR_URL;
                    dispatch(setSelectedUser(set(selectedUser, 'avatar', avatar)));
                } else {
                    const selectedUser = structuredClone(chatData);
                    const avatar = chatData?.avatar
                    ? await getProfileImage({ profileImg: chatData[0]?.avatar })
                    : DEFAULT_AVATAR_URL;
                    dispatch(setSelectedUser(set(selectedUser, 'avatar', avatar)));
                }
                dispatch(setCurrentView(CURRENT_VIEW.MESSAGE_VIEW));
            } catch (error) {
            popup('error', error.message);
        } finally {
            setIsFetching(false);
        }
    };

    return (
        <div className='new-chat-container'>
            {isFetching ? (
                <span className='position-absolute top-50 start-50'>
                    <Spinner variant='success' />
                </span>
            ) : (
                chatUsers?.map((user) => (
                    <div key={user.id} className='new-chat-user'>
                        <Avatar
                            src={user?.avatar}
                            alt={user?.full_name}
                            type='circle'
                            size={'medium'}
                        />
                        <span className='user-detail'>
                            <span className=' user-name fw-bold' title={user?.full_name}>
                                {user?.full_name}
                            </span>
                            <span className=' user-email text-mute' title={user?.email}>
                                {user?.email}
                            </span>
                        </span>
                        <button
                            className='new-chat-btn'
                            type='button'
                            id='action-icon'
                            onClick={() => initiateChat(user?.id)}
                            title={'Start Chat'}
                        >
                            <ChatIcon />
                        </button>
                    </div>
                ))
            )}
        </div>
    );
};
